'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cruiTagSelect = require('@alicd/crui-tag-select');

var _cruiTagSelect2 = _interopRequireDefault(_cruiTagSelect);

var _cruiFormItem = require('@alicd/crui-form-item');

var _cruiFormItem2 = _interopRequireDefault(_cruiFormItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagSelectField = function (_React$Component) {
  (0, _inherits3.default)(TagSelectField, _React$Component);

  function TagSelectField() {
    (0, _classCallCheck3.default)(this, TagSelectField);
    return (0, _possibleConstructorReturn3.default)(this, (TagSelectField.__proto__ || (0, _getPrototypeOf2.default)(TagSelectField)).apply(this, arguments));
  }

  (0, _createClass3.default)(TagSelectField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          bind = _props.bind,
          style = _props.style,
          inputStyle = _props.inputStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['bind', 'style', 'inputStyle']);
      var labelCol = other.labelCol,
          wrapperCol = other.wrapperCol,
          mapping = other.mapping,
          className = other.className,
          otherInput = (0, _objectWithoutProperties3.default)(other, ['labelCol', 'wrapperCol', 'mapping', 'className']);


      if (other.className) {
        other.className += ' tag-select-field';
      } else {
        other.className = 'tag-select-field';
      }

      return _react2.default.createElement(
        _cruiFormItem2.default,
        (0, _extends3.default)({}, other, { style: style }),
        _react2.default.createElement(_cruiTagSelect2.default, (0, _extends3.default)({}, otherInput, { style: inputStyle }))
      );
    }
  }]);
  return TagSelectField;
}(_react2.default.Component);

exports.default = TagSelectField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-tag-select-field@0.0.23@@alicd/crui-tag-select-field/lib/index.js
// module id = 714
// module chunks = 0